<template>
    <BaseComponent name="social">
        <p class="h6 mt-4 mt-lg-0">{{ $t('Social') }}</p>
        <ul class="list-unstyled d-flex justify-content-between justify-content-sm-start flex-row mb-0">
            <li v-for="social in useSettingsStore().social" class="me-3">
                <a :class="`footer-icon footer-${social.code}`" :title="social.name" :href="social.link" target="_blank" rel="noopener noreferrer">{{social.name}}</a>
            </li>
        </ul>
    </BaseComponent>
</template>

<script setup>
import {useSettingsStore} from "~/stores/SettingsStore";
</script>
